/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {DasUBootRoundType} from "../server/DasUBootData";
import {SymbolUtils} from "../utils/SymbolUtils";


export class DasUBootIdleNormalPresentation implements FlowStatePresentation {
    private _tl:gsap.core.Timeline | undefined;


    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const wasFreespin = DasUBoot.model.data.roundType == DasUBootRoundType.FREE_SPIN || DasUBoot.model.data.roundType == DasUBootRoundType.SUPER_FREE_SPIN;
        //const wasAvalanche = DasUBoot.model.gameData?.mode == DasUBootGameMode.AVALANCHE;
        const allowedMode:boolean = DasUBoot.model.data.roundType == DasUBootRoundType.NORMAL && !wasFreespin && !DasUBoot.model.winCapReached;
        const hasWin:boolean = DasUBoot.model.gameData?.betWayWins.length > 0;

        if (DasUBoot.model.winCapReached){
            SymbolUtils.getSymbolStateAnimations(DasUBoot.reelView.getAllVisibleSymbols(), DasUBootSymbolStates.NORMAL)
        }

        for (let symbol of DasUBoot.reelView.getAllVisibleSymbols()) {
            (<DasUBootSymbol>symbol.positionable).resetFrame();
        }

        if (hasWin && allowedMode) {
            this._tl = gsap.timeline();
            this._tl.add(gsap.to(this, {duration:0.3})); //Small delay so not to "flash" win line during autoplay.
            this._tl.add(this.getWinLineToggleAnimation());

            flowStateController.setSkipCallback(() => this.skip(flowStateController));
        } else {
            this.complete(flowStateController);
        }

    }

    private complete(flowStateController:FlowStateController) {
        flowStateController.finish();
        delete this._tl;
    }


    private skip(flowStateController:FlowStateController):void {
        if (this._tl) {
            this._tl.kill();
        }

        DasUBoot.winView.showWinWayDisplay(0, 0, 0, new PIXI.Point(), 0);
        this.complete(flowStateController);
    }


    private getWinLineToggleAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({repeat:-1});

        for (let win of DasUBoot.model.clientData.winData.lines) {
            const lineAnimation = [];
            const lineTl:gsap.core.Timeline = gsap.timeline();

            for (let pos of win.winCoordinates) {
                const symbolData:SimpleReelModelSymbolData = DasUBoot.reelView.getVisibleSymbolAt(pos.column, pos.row);
                const symbol:DasUBootSymbol = <DasUBootSymbol>symbolData.positionable;
                lineAnimation.push(symbol.getStateAnimation(DasUBootSymbolStates.WIN_TOGGLE));

            }

            lineTl.add(lineAnimation);
            lineTl.add(gsap.to(this, {duration:0.2}));

            const winWayPos = new PIXI.Point(360, 360);
            const winWaysToggle = DasUBoot.winView.showWinWayDisplay(win.betWayWin.multipliedAmount, win.betWayWin.multiplier, win.betWayWin.numberOfCombinations, winWayPos, lineTl.duration());
            lineTl.add(winWaysToggle, 0);

            tl.add(lineTl);

        }

        return tl;
    }

}